import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from '../model/constants';
import { Utils } from './utils/utils';
import { CorsoModulo } from '../model/corsomodulo';

@Injectable({
  providedIn: 'root'
})
export class ModuloService {

    constructor(private http: HttpClient) { }

    getModuloCertificazione(moduleId: number): Observable<CorsoModulo> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'modulo/certificazione/' + moduleId;
        return this.http.get<CorsoModulo>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    getModuloFigli(moduleId: number): Observable<CorsoModulo> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'modulo/figli/' + moduleId;
        return this.http.get<CorsoModulo>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    getModuleParentsStruct(moduleId: number): Observable<Array<CorsoModulo>> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'modulo/parents/' + moduleId;
        return this.http.get<Array<CorsoModulo>>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    getModuliWithEsercitazioni(courseId: number): Observable<Array<CorsoModulo>> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'modulo/esercitazioni/' + courseId;
        return this.http.get<Array<CorsoModulo>>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    getModuliWithEsercitazioni2(courseId: number, moduloPadreId: number): Observable<Array<CorsoModulo>> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'modulo/esercitazioni/' + courseId + '/' + moduloPadreId;
        return this.http.get<Array<CorsoModulo>>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    countSlides(courseId: number, moduleId: number): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'modulo/slide/count/' + courseId + '/' + moduleId;
        return this.http.get(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    downloadPdfModulo(courseId: number, moduleId: number): Observable<Blob> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'modulo/download/' + courseId + '/' + moduleId;
        return this.http.get<Blob>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            // {headers}
            {headers, responseType: 'blob' as 'json'}
        );
    }

    public async downloadResource(courseId: number, moduleId: number): Promise<Blob> {
        const url = 'modulo/download/' + courseId + '/' + moduleId;
        const file =  await this.http.get<Blob>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {responseType: 'blob' as 'json'}
        ).toPromise();

        return file;
    }
}
